import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../common/components/Checkbox';
import InputFieldErrorMessage from '../../../../common/components/InputFieldErrorMessage';
import styles from './ArticleLicensingTermsField.module.scss';

const ArticleLicensingTermsField = ({
  field,
  onChange,
  labelContent,
  descriptionContent,
}) => {
  return (
    <div className={styles.termsField}>
      <Checkbox
        id={field.name}
        className={styles.termsField__checkbox}
        name={field.name}
        checked={field.value}
        onChange={onChange}
        size={20}
      />
      <div className={styles.termsField__helpText}>
        <span className={styles.termsField__helpText__label}>
          {labelContent}
        </span>
        <p className={styles.termsField__helpText__description}>
          {descriptionContent}
        </p>
        <InputFieldErrorMessage field={field} noMargin />
      </div>
    </div>
  );
};

ArticleLicensingTermsField.propTypes = {
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.bool,
    touched: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  labelContent: PropTypes.node.isRequired,
  descriptionContent: PropTypes.node.isRequired,
};

export default ArticleLicensingTermsField;
